import * as React from 'react';

export interface Props {
  id?: string;
  isLargeHeader?: boolean;
  headerText: React.ReactChild | null;
  footerText?: React.ReactChild | null;
}

export const TitleText: React.FC<Props> = (props) => {
  const { headerText, footerText, isLargeHeader, id } = props;
  return (
    <>
      <div id={id} />
      <p className={`kxi-text-600 ${isLargeHeader ? 'kxi-text-xlarge' : 'kxi-text-large'}`}>{headerText}</p>
      <br />
      <p>{footerText}</p>
    </>
  );
};
